import axios from "axios";

import myConfig from "../../configs/config";
import {
  allPeriodDaysSelected,
  dayKeysForPeriod,
  periodEndsToday,
  todayIso,
} from "./fieldAppPeriodUtils";
import { isValidTrackingCoordinate } from "./fieldAppTrackingUtils";

export function isTodayVisibleInTracking(
  selection,
  selectedDayKeys = [],
  periodDayKeys = []
) {
  if (!selection || !periodEndsToday(selection)) return false;

  const today = todayIso();
  const periodDays = periodDayKeys.length
    ? periodDayKeys
    : dayKeysForPeriod(selection.dateFrom, selection.dateTo);

  if (periodDays.indexOf(today) === -1) return false;
  if (!selectedDayKeys || !selectedDayKeys.length) return true;
  if (allPeriodDaysSelected(periodDays, selectedDayKeys)) return true;
  return selectedDayKeys.indexOf(today) !== -1;
}

export async function fetchLiveEquipmentPosition(farmId, machineIdent) {
  if (!farmId || !machineIdent) return null;

  const response = await axios.get(
    `${myConfig.API_URL}/equipment/equipments_info/?farm_id=${farmId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    }
  );

  if (response.status !== 200 || !Array.isArray(response.data)) {
    return null;
  }

  const match = response.data.find((item) => item.ident === machineIdent);
  if (!match || !match.last_posi_point) {
    return null;
  }

  const lastPoint = match.last_posi_point;
  if (!isValidTrackingCoordinate(lastPoint)) {
    return {
      lat: null,
      lng: null,
      speed: match.speed,
      last_connection: match.last_connection,
      machine_status: match.machine_status,
      traccar_ico: match.traccar_ico,
    };
  }

  return {
    lat: lastPoint.lat,
    lng: lastPoint.lng,
    speed: match.speed,
    last_connection: match.last_connection,
    machine_status: match.machine_status,
    traccar_ico: match.traccar_ico,
  };
}

export const LIVE_EQUIPMENT_POLL_MS = 60 * 1000;
